import { ExpoConfig } from '@expo/config-types'

const config: ExpoConfig = {
  scheme: 'consultormaisturbo',
  owner: 'laboritinc',
  name: 'Consultor Mais Turbo',
  slug: 'consultor-mais-turbo',
  version: '2.9.0',
  icon: './assets/icon.png',
  plugins: [
    [
      'expo-build-properties',
      {
        ios: {
          useFrameworks: 'static'
        },
        android: {
          compileSdkVersion: 33,
          targetSdkVersion: 33,
          buildToolsVersion: '33.0.0',
          kotlinVersion: '1.7.10'
        }
      }
    ],
    [
      'expo-image-picker',
      {
        photosPermission: `Allow access to your device's photo library to select a picture for your profile.`,
        cameraPermission: `Allow access to your device's camera to take a picture for your profile.`
      }
    ],
    [
      'expo-document-picker',
      {
        iCloudContainerEnvironment: 'Production'
      }
    ],
    [
      'expo-screen-orientation',
      {
        initialOrientation: 'PORTRAIT_UP'
      }
    ],
    'react-native-compressor',
    'sentry-expo',
    '@react-native-firebase/app',
    './plugins/withAndroidVerifiedLinksWorkaround'
  ],
  splash: {
    image: './assets/splash.png',
    resizeMode: 'cover',
    backgroundColor: '#ffffff'
  },
  updates: {
    fallbackToCacheTimeout: 0,
    url: 'https://u.expo.dev/19c4d917-7bf3-42af-9c6a-ecae193917ff'
  },
  assetBundlePatterns: ['**/*'],
  ios: {
    buildNumber: '49',
    supportsTablet: true,
    bundleIdentifier: 'com.webmotors.consultormaisturbo',
    associatedDomains: [
      'applinks:www.consultormaisturbo.com.br',
      'applinks:hml.consultormaisturbo.com.br'
    ],
    infoPlist: {
      NSCameraUsageDescription: `Allow access to your device's camera to take a picture for your profile.`,
      LSApplicationQueriesSchemes: ['lyft', 'whatsapp']
    },
    googleServicesFile: './GoogleService-Info.plist',
    config: {
      usesNonExemptEncryption: false
    }
  },
  notification: {
    icon: './assets/icon-notification.png',
    color: '#070707'
  },
  runtimeVersion: {
    policy: 'sdkVersion'
  },
  android: {
    versionCode: 49,
    googleServicesFile: './google-services.json',
    adaptiveIcon: {
      foregroundImage: './assets/adaptive-icon.png',
      backgroundColor: '#FFFFFF'
    },
    package: 'com.webmotors.consultormaisturbo',
    intentFilters: [
      {
        action: 'VIEW',
        autoVerify: true,
        data: [
          {
            scheme: 'https',
            host: 'hml.consultormaisturbo.com.br'
          }
        ],
        category: ['BROWSABLE', 'DEFAULT']
      },
      {
        action: 'VIEW',
        autoVerify: true,
        data: [
          {
            scheme: 'https',
            host: '*.consultormaisturbo.com.br',
            pathPrefix: '/cadastro/email/confirmacao/processando'
          }
        ],
        category: ['BROWSABLE', 'DEFAULT']
      }
    ]
  },
  web: {
    favicon: './assets/favicon.png',
    build: {
      babel: {
        include: ['victory-native']
      }
    }
  },
  extra: {
    eas: {
      projectId: '19c4d917-7bf3-42af-9c6a-ecae193917ff'
    }
  }
}

export default config
